var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRollupOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 46,
    viewBox: "0 0 58 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 55,
    height: 44,
    stroke: "#8A8A8A",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 54,
    height: 5,
    stroke: "#8A8A8A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 23.5,
    width: 54,
    height: 5,
    stroke: "#8A8A8A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12.5,
    width: 54,
    height: 5,
    stroke: "#8A8A8A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 33.5,
    width: 54,
    height: 6,
    stroke: "#8A8A8A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6.5,
    width: 54,
    height: 6,
    fill: "#F8F8F8",
    stroke: "#8A8A8A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 28.5,
    width: 54,
    height: 5,
    fill: "#F8F8F8",
    stroke: "#8A8A8A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17.5,
    width: 54,
    height: 6,
    fill: "#F8F8F8",
    stroke: "#8A8A8A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 39.5,
    width: 54,
    height: 5,
    fill: "#F8F8F8",
    stroke: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollupOrder);
export default __webpack_public_path__ + "static/media/rollup-order.7048fb30d9c78ce79108e7b168277563.svg";
export { ForwardRef as ReactComponent };